module.exports = __webpack_public_path__ + "img/main-mobile.81376791.png";